import { PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../../models/UserState";
import { UserLoginPayload } from "../../payload/UserLoginPayload";

const getUserDataFetch = (state: UserState, action: PayloadAction<UserLoginPayload>) => {
    state.isLoading = true;
}

export default getUserDataFetch;